export const githubUrls = (name, items) => {
    switch (name) {
        case 'GET_TILES_DATA': {
            return '/api/stats/stones'
        }
        default: { }
    }

}   